export const setGradient = (color1, color2) => `linear-gradient(225deg, ${color1}, ${color2})`;
